import * as documentActions from '@src/state/document/actions'
import {
  CLEAR_ALL_MODALS,
  HIDE_MODAL,
  ModalPropsPayloads,
  SHOW_MODAL,
  UPLOAD_WIDGET_MODAL,
} from '@src/state/modals/actions'
import { DocumentActions, GlobalActions, ModalsActions } from '@src/types/actions'
import { getType } from 'typesafe-actions'
import { resetState } from '../actions'

// https://www.typescriptlang.org/docs/handbook/advanced-types.html
export type ModalState = { [P in keyof ModalPropsPayloads]?: ModalPropsPayloads[P] }

const initialState: ModalState = {}

const modalReducer = (
  state: ModalState = initialState,
  action: ModalsActions | DocumentActions | GlobalActions
) => {
  switch (action.type) {
    case CLEAR_ALL_MODALS:
      return initialState
    case SHOW_MODAL:
      return {
        ...state,
        [action.payload.name]: action.payload.modalProps,
      }
    case HIDE_MODAL:
      const { [action.payload.name]: _, ...newState } = state
      return newState
    case getType(documentActions.handleDocumentCreate):
      const { [UPLOAD_WIDGET_MODAL]: uploadWidgetModalState, ...restState } = state
      return restState
    case getType(resetState): {
      return initialState
    }
    default:
      return state
  }
}

export default modalReducer



// WEBPACK FOOTER //
// ./src/state/modals/reducer.ts